import { usePipelineStore } from '../../store/pipelineStore';
import { useAppStore } from '../../store/appStore';
import { useDashboardStackStore } from '../../store/dashboardStackStore';
import { useLogicStore } from '../../store/logicStore';
import { useAgentStore } from '../../store/agentStore';
import { useOntologyStore } from '../../store/ontologyStore';
import { useConnectorStore } from '../../store/connectorStore';
import { useWorkbenchStore } from '../../store/workbenchStore';
import { useUiStore } from '../../store/uiStore';
import { useExplorerStore } from '../../store/explorerStore';
import { useDomainStore } from '../../store/domainStore';
import { resourceInProject, useWorkspaceStore } from './workspaceStore';

/** Editors cache drafts by resource ID; discard them before changing scope. */
export function clearModuleState() {
  usePipelineStore.setState({ pipelines: [], selectedPipelineId: null });
  useAppStore.setState({ apps: [] });
  useDashboardStackStore.getState().clear();
  useLogicStore.setState({ functions: [], selectedFn: null, runs: [], lastRun: null });
  useAgentStore.setState({ agents: [], selectedAgent: null, selectedThread: null, threads: [], messages: [], schedules: [] });
  useOntologyStore.setState({ objectTypes: [], links: [] });
  useDomainStore.setState({ domains: [], domainLinks: [], domainsByOt: {}, focusedDomainId: null });
  useConnectorStore.setState({ connectors: [] });
  useExplorerStore.setState({ objectTypes: [], selectedTypeId: null, fields: [], recordCount: 0, filters: [], aggregate: null, groupBy: null, result: null, analystResult: null, links: null, trail: [], pivotError: null });
  useWorkbenchStore.setState({ notebooks: [], currentNotebookId: null, kernelSessionId: null });
  useUiStore.setState({ activeObjectPanel: null });
}

/** Reference pickers may have populated a shared cache with the full inventory.
 * Narrow that cache before painting its own module, retaining open selections. */
export function scopeModuleState(page: string) {
  if (!useWorkspaceStore.getState().projectId) return;
  if (page === 'apps' || page === 'apps-app' || page.startsWith('app-'))
    useAppStore.setState(s => ({ apps: s.apps.filter(r => resourceInProject('app', r.id)) }));
  if (page === 'pipelines' || page === 'ontology')
    usePipelineStore.setState(s => ({ pipelines: s.pipelines.filter(r => resourceInProject('pipeline', r.id)) }));
  if (page === 'ontology' || page === 'graph') {
    useOntologyStore.setState(s => ({ objectTypes: s.objectTypes.filter(r => resourceInProject('object_type', r.id)) }));
    useConnectorStore.setState(s => ({ connectors: s.connectors.filter(r => resourceInProject('connector', r.id)) }));
  }
  if (page === 'connectors') useConnectorStore.setState(s => ({ connectors: s.connectors.filter(r => resourceInProject('connector', r.id)) }));
  if (page === 'logic') useLogicStore.setState(s => ({ functions: s.functions.filter(r => resourceInProject('function', r.id)) }));
  if (page === 'agents') useAgentStore.setState(s => ({ agents: s.agents.filter(r => resourceInProject('agent', r.id)) }));
  if (page === 'workbench') useWorkbenchStore.setState(s => ({ notebooks: s.notebooks.filter(r => resourceInProject('notebook', r.id)) }));
  if (page === 'data') useExplorerStore.setState(s => ({ objectTypes: s.objectTypes.filter(r => resourceInProject('object_type', r.id)) }));
}
